import React from 'react';
import { Link } from '@zola/zola-ui/src/components/Link';
import OtherThingsToReview from './OtherThingsToReview';

function TipThankYouCard() {
  return (
    <div className="etiquette-tip-modal">
      <div className="tip-content-container">
        <div className="modal-body">
          <h3>7 Tips For Wedding Thank You Notes</h3>
          <div className="section">
            <p className="desc">
              While you might hear conflicting “rules” about how long you have to send your wedding
              thank you notes &#40;we believe in the 3-month rule&#41;, there are a few basic thank
              you card pointers you should follow when the time does come to take pen to paper:
            </p>
          </div>
          <div className="section">
            <p className="head">1. Be specific.</p>
            <p className="desc">
              Be specific in your thanks by mentioning exactly what you received as a gift and how
              you plan to use it. One exception is for monetary gifts: while it&#39;s great to
              mention how you plan to use the funds, it is best to not mention the exact amount.
            </p>
          </div>
          <div className="section">
            <p className="head">2. Make it personal.</p>
            <p className="desc">
              Mention a small detail about the person who gave you the gift, such as their part in
              the wedding or a time in the future that you will see them.
            </p>
          </div>
          <div className="section">
            <p className="head">3. Be yourself.</p>
            <p className="desc">
              While thank you notes are a formality by nature, it&#39;s important to use your true
              voice. This card not only shows your appreciation but is meant to make someone happy,
              so keeping it authentic is important.
            </p>
          </div>
          <div className="section">
            <p className="head">4. Write clearly.</p>
            <p className="desc">
              While you don’t need to enroll in a calligraphy class, a legible message shows that
              you took the time to write something that can be easily read.
            </p>
          </div>
          <div className="section">
            <p className="head">5. Share the responsibility.</p>
            <p className="desc">You and your partner should both sign your names!</p>
          </div>
          <div className="section">
            <p className="head">6. Make it special.</p>
            <p className="desc">
              Give your guests and gift-givers something special. Choose a beautiful card design
              that will make your thoughtful thank you notes more memorable—and even better if your
              cards coordinate with the rest of your wedding invitation suite!
            </p>
          </div>
          <div className="section">
            <p className="head">7. Use Zola&#39;s free tools.</p>
            <p className="desc">
              Our free{' '}
              <Link
                inline
                href="/wedding-registry/benefits/thank-you-manager"
                target="_blank"
                rel="noopener noreferrer"
              >
                Thank You Note Manager
              </Link>{' '}
              is integrated into your Zola Registry and will make your thank you note-writing
              process so much easier. Automatically track &#40;and then download!&#41; who sent you
              what, the date the gift was sent, and the giver’s address.
            </p>
          </div>
          <div className="section">
            <p className="desc">
              Learn even more by reading the full article on{' '}
              <Link
                inline
                href="/expert-advice/invites-paper/thank-you-notes/how-to-write-wedding-thank-you-cards"
                target="_blank"
                rel="noopener noreferrer"
              >
                How To Write Wedding Thank You Cards
              </Link>
              . Want sample thank you note language? Check out{' '}
              <Link
                inline
                href="/expert-advice/invites-paper/thank-you-notes/how-to-word-wedding-thank-you-cards"
                target="_blank"
                rel="noopener noreferrer"
              >
                How To Word Wedding Thank You Cards
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
      <OtherThingsToReview />
    </div>
  );
}

export default TipThankYouCard;
